import IncentiveOfferOperationDetail from 'modules/incentivesMarket/pages/IncentiveOfferOperationDetail';
import { IncentiveOfferOperationDetailProvider } from '../pages/IncentiveOfferOperationDetail/context/IncentiveOfferOperationDetailContext';

const IncentiveOfferOperationDetailContainer = () => (
  <IncentiveOfferOperationDetailProvider>
    <IncentiveOfferOperationDetail />
  </IncentiveOfferOperationDetailProvider>
);

export default IncentiveOfferOperationDetailContainer;
